export const Actiontypes = {
    PROFILE:"PROFILE",
    NEWS:"NEWS",
  };
  